/* eslint-disable */
import createIcon from '../createIcon';

const IconSwitchTick = createIcon({
  name: 'icon-switch-tick',
  content: '<path d="M806.784 295.744l45.248 45.184L489.92 702.976l-45.184 45.312-226.24-226.24 45.184-45.184 180.992 180.928z"/>',
  width: 1024,
  height: 1024
});
export default IconSwitchTick;
